import { useMemo, useRef } from 'react'
import CocreatedBy from '../NewPostPaymentFeature/CocreatedBy'
import { useSelector } from 'react-redux'
import { selectLoadingStatus, selectSuggestedCourseDetail } from '../../redux/postPaymentSlice'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import NewProjectsAndOutcomes from '../AnalysisPage/NewProjectsAndOutcomes'
import NewSyllabusDetails from '../AnalysisPage/NewSyllabusDetails'

const features = [
    <span><span className='text-span_color'>Learn 2X Faster</span> With The Syllabus Personalized To Your Strengths & Weaknesses</span>,
    'Evaluation Test With Live Feedback After Every Video Lesson',
    '24/7 Live Doubt Solving',
    'Life-Time Access'
]

const PersonlaisedCourseSection = ({ skillName }) => {

    const courseDetail = useSelector(selectSuggestedCourseDetail)
    const loading = useSelector(selectLoadingStatus)

    const outcome = courseDetail?.outcome
    const projects = courseDetail?.projects

    const lessonRef = useRef(null)
    const projectRef = useRef(null)

    const scrollToLesson = (ref) => {
        if (ref.current){
            ref.current.scrollIntoView({ behavior: 'smooth' })
        }
    }

    const lesson = useMemo(() => {
        return courseDetail?.syllabus?.reduce((count, item) => item?.lesson_list?.length + count, 0)
    }, [courseDetail])

    return (
        <div className='flex flex-col gap-4'>
            <div className='bg-bg-13/[15%] px-4 py-3 rounded-2xl text-xs'>
                {loading ? <div className='flex w-full justify-between gap-3 items-center pb-3 border-b-[1.5px] h-[58px] border-[#335373]'>
                    <div className='flex-1 bg-[#335373] rounded-lg h-full animate-pulse-opacity'>

                    </div>
                    <div className='flex-1 bg-[#335373] rounded-lg h-full animate-pulse-opacity'>

                    </div>
                    <div className='flex-1 bg-[#335373] rounded-lg h-full animate-pulse-opacity'>

                    </div>
                    <div className='flex-1 bg-[#335373] rounded-lg h-full animate-pulse-opacity'>

                    </div>
                </div> : <div className='flex flex-wrap justify-center gap-4 text-center pb-3 border-b-[1.5px] border-[#335373]'>
                    <div className='flex items-center cursor-pointer gap-2 underline underline-offset-2' onClick={() => scrollToLesson(lessonRef)}>
                        <img src="https://assets.learntube.ai/files/New%20Analysis%20Page/lessons.svg?updatedAt=1741780118524" width={12} height={16} alt="" />
                        <p className='leading-3'>{lesson} Lessons</p>
                    </div>
                    <div className='flex items-center gap-2'>
                        <img src="https://assets.learntube.ai/files/New%20Analysis%20Page/timer.svg?updatedAt=1741780494049" width={16} height={16} alt="" />
                        <p className=''>{`${Math.floor((lesson * 15)/60)}hr ${(lesson*15)%60 === 0 ? '': (lesson*15)%60+'m'}`}</p>
                    </div>
                    <div className='flex items-center gap-2 cursor-pointer underline underline-offset-2' onClick={() => scrollToLesson(projectRef)}>
                        <img src="https://assets.learntube.ai/files/New%20Analysis%20Page/Component%2078.svg?updatedAt=1741780582847" width={14} height={16} alt="" />
                        <p className='leading-3'>{projects?.slice(0, 5)?.length} Projects</p>
                    </div>
                    <div className='flex gap-2 items-center'>
                        <img src="https://assets.learntube.ai/files/New%20Analysis%20Page/Component%2077.svg?updatedAt=1741780644026" width={14} height={12} alt="" />
                        <p className=''>Certificate Of Completion</p>
                        
                    </div>
                </div>}
                <CocreatedBy
                    skillName={skillName}
                />
            </div>
            <div>
                <h3 className='font-semibold'>Learning Features</h3>
                <div className='mt-3 rounded-xl bg-bg-13/[15%]'>
                    {features?.map((item, index) => (
                        <div className={`flex items-center gap-2 py-3 px-3 ${index !== features?.length - 1 && 'border-b-[0.8px] border-[#395C7E]'}`}>
                            <div className='w-4 h-4 rounded-full bg-secondary-text flex items-center justify-center'>
                                <FontAwesomeIcon icon={faCheck} className='text-xs' />
                            </div>
                            <p className='text-sm font-medium flex-1'>{item}</p>
                        </div>
                    ))}
                </div>
            </div>
            <div>
                <h3 className='font-semibold text-lg mb-3'>Outcomes</h3>
                <div className=''>
                    {loading ? <div className=''>
                        {Array.from({ length: 5}, (_, index) => (
                            <div key={index} className={`bg-[#14395F] border-b px-2 py-6 animate-pulse-opacity flex items-center gap-2`}>
                            
                            </div>
                        ))}
                    </div>
                    : <NewProjectsAndOutcomes
                        list={outcome}
                        image={'https://assets.learntube.ai/files/New%20Analysis%20Page/Group%2022250.svg?updatedAt=1741781650793'}
                        width={20}
                        height={20}
                    />}
                </div>
            </div>
            <div className=''>
                <h3 ref={lessonRef} className='font-semibold text-lg mb-3'>Your Personalized Syllabus</h3>
                <NewSyllabusDetails
                    loading={loading}
                />
            </div>
            <div className=''>
                <h3 ref={projectRef} className='font-semibold text-lg mb-3'>Projects</h3>
                <div className=''>
                    {loading ? <div className=''>
                        {Array.from({ length: 5}, (_, index) => (
                            <div key={index} className={`bg-[#14395F] ${index === 0 ? 'rounded-t-xl' : index === 4 ? 'rounded-b-xl' : ''} border-b px-2 py-6 animate-pulse-opacity flex items-center gap-2`}>
                            
                            </div>
                        ))}
                    </div> :
                    <NewProjectsAndOutcomes
                        list={projects}
                        image={'https://assets.learntube.ai/files/new-post-certificate-purchase/Untitled.svg?updatedAt=1740823904765'}
                        width={25}
                        height={25}
                    />}
                </div>
            </div>
        </div>
    )
}

export default PersonlaisedCourseSection